

exports.__esModule = true;

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/fi/index');

var _index2 = require('xo-models/src/checkout/index');

require('xo-tray-height/dist/directive');

require('xo-ui-components/src/popup/directive');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/accessibility/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$SidebarManageWalletDirective', {

    tag: 'xo-manage-wallet',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        showInfoMsg: function showInfoMsg($index) {
            this.disallowedIndex = $index;
        },
        confirm: function confirm($index) {
            this.selectedIndex = $index;
            this.deleteCard = true;
        },
        deleteFS: function deleteFS(fundingsource) {
            var _this = this;

            /* Call walletfiserv to delete selected card and call Symphony's notifyChangeFundingInstruments api
             to get back updated funding options.
             */
            this.deleteCardModel = new _index.$DeleteCardModel({
                id: fundingsource.id
            });

            this.deleteCardModel.save({
                data: this.deleteCardModel,

                contingencies: {
                    DELETE_CARD_CONTINGENCY: function DELETE_CARD_CONTINGENCY() {
                        _this.handleSingleContingency('creditcard.errorDeleteCard');
                        return;
                    }
                },

                error: function error() {
                    _this.handleSingleContingency('creditcard.errorDeleteCard');
                    return;
                },

                /* Call notifyChangeFundingInstruments to get updated funding options from checkout session
                 During this call if any error or contignecies return back, just remove the deleted FI from checkout
                 session as its already deleted successfully
                 */

                success: function success() {
                    _this.models.checkoutSession.fundingOptions.action('notifyChange', {
                        resultModel: _this.models.checkoutSession,

                        data: {
                            planId: fundingsource.id,
                            operation: 'REMOVED'
                        },
                        success: function success() {
                            _logger.$logger.info('manage_wallet: deleted FI - 1', fundingsource.id);
                            _this.selectedIndex = -1;
                            _this.disallowedIndex = -1;
                        },
                        contingencies: {
                            NOTIFY_FUNDING_CHANGE_CONTINGENCY: function NOTIFY_FUNDING_CHANGE_CONTINGENCY() {
                                _this.removeFIFromCheckoutSession(fundingsource);
                                return;
                            }
                        },
                        error: function error() {
                            _this.removeFIFromCheckoutSession(fundingsource);
                            return;
                        }
                    });
                }
            });
        }
    },

    lifecycle: {
        populate: function populate() {
            this.models.checkoutSession.reload();
            if (this.models.checkoutSession) {
                this.message = this.models.checkoutSession.message;
                this.isSysmtemError = this.message && this.message.type === 'error';
                this.models.checkoutSession.message = null;
            }
        },
        enter: function enter() {

            this.locale = _squid.$locale;
            this.doneFn = function (result) {
                _uiRouter.$state.go('checkout.review');
            };

            this.handleSingleContingency = function (errorKey) {
                var messages = [];

                messages.push(_squid.$locale.content.get(errorKey));

                this.message = {
                    msgs: messages,
                    type: 'error'
                };
                this.isSysmtemError = true;
                this.selectedIndex = -1;
                this.disallowedIndex = -1;
            };

            this.removeFIFromCheckoutSession = function (fundingsource) {
                this.models.checkoutSession.fundingOptions.instruments = this.models.checkoutSession.fundingOptions.instruments.filter(function (item) {
                    return item.id !== fundingsource.id;
                });
            };
        }
    }
});


_uiRouter.$state;

_squid.$Component;

_squid.$locale;

_logger.$logger;

_index.$DeleteCardModel;

_index2.$CheckoutSessionModel;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sidebar-manage-wallet/directive.js
 ** module id = 352
 ** module chunks = 1
 **/